import React from 'react';

import { Stack } from '@lyearn/ui';
import { FtbResponse } from '@/types/schema';

import { QuizPlayerFieldProps } from '../../types';
import DropdownPlayer from './components/DropdownPlayer';

function FtbPlayer(props: QuizPlayerFieldProps) {
  const { question, onChange, correctAnswers, questionAttempt } = props;
  const ftbResponse = questionAttempt?.submission?.ftbResponse || [];

  const _onChange = React.useCallback(
    (ftbResponse: FtbResponse[]) => {
      onChange?.({ ftbResponse });
    },
    [onChange],
  );

  if (!question.ftbComponents) {
    return null;
  }

  return (
    <Stack direction="col">
      <DropdownPlayer
        correctFtbAnswers={correctAnswers?.correctFTBAnswers}
        ftbComponents={question.ftbComponents}
        ftbResponse={ftbResponse}
        globalDistractedOptions={question.globalDistractedOptions || []}
        isQuestionSubmitted={Boolean(questionAttempt?.isSubmitted)}
        onChange={_onChange}
      />
    </Stack>
  );
}

export default FtbPlayer;
